import * as tslib_1 from "tslib";
import IconBar from './shared/IconBar';
import { getIconClassName } from '@uifabric/styling/lib/index';
import { observer } from 'mobx-react';
import { resetFocus } from 'owa-mail-focus-manager';
import * as lazyTriageActions from 'owa-mail-triage-action';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import doesFolderIdEqualName from 'owa-session-store/lib/utils/doesFolderIdEqualName';
import { lazyMarkItemsAsReadBasedOnItemIds } from 'owa-mail-mark-read-actions';
import { listViewStore } from 'owa-mail-list-store';
import { getPropertyIconStyle, PropertyIcons } from 'owa-mail-list-actions';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import getItemClassIcon from 'owa-mail-list-actions/lib/utils/conversationProperty/getItemClassIcon';
import { isGroupTableQuery } from 'owa-group-common';
import { isConsumer } from 'owa-session-store';
import { DefaultPalette } from '@uifabric/styling/lib/styles';
import { getItemToShowFromNodeId } from 'owa-mail-store/lib/utils/conversationsUtils';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
var styles = require('./MailListItemPart.scss');
var classNames = require('classnames/bind').bind(styles);
/*
Renders the mail list item part icon bar for both action icons and property icons
*/
var MailListItemIconBar = /** @class */ (function (_super) {
    tslib_1.__extends(MailListItemIconBar, _super);
    function MailListItemIconBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deleteRow = function (item) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var parentFolderId, tableView;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parentFolderId = item.ParentFolderId && item.ParentFolderId.Id;
                        tableView = listViewStore.tableViews.get(this.props.tableViewId);
                        return [4 /*yield*/, lazyTriageActions.lazyDeleteItems.importAndExecute([item.ItemId.Id], doesFolderIdEqualName(parentFolderId, 'deleteditems')
                                ? 'SoftDelete'
                                : 'MoveToDeletedItems', 'ItemPartIconLV', null, getMailboxInfo(tableView))];
                    case 1:
                        _a.sent();
                        // Reset focus after the lazy action is complete, to ensure that focus is set
                        // after any confirm dialogs are dismissed and the stitch has been raised
                        resetFocus();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.toggleMarkAsReadRow = function (item) {
            var tableView = listViewStore.tableViews.get(_this.props.tableViewId);
            lazyMarkItemsAsReadBasedOnItemIds.importAndExecute(tableView, [item.ItemId.Id], !item.IsRead, true, 'ItemPartIconLV', null);
            // Reset focus after the stitch to mark the item as read is raised
            resetFocus();
        };
        _this.toggleFlaggedStateRow = function (item) {
            var isFlagged = item.Flag.FlagStatus == 'Flagged';
            var parentFolderId = item.ParentFolderId && item.ParentFolderId.Id;
            var flagStatusValueToSet;
            if (isFlagged) {
                flagStatusValueToSet = 'NotFlagged';
            }
            else {
                flagStatusValueToSet = 'Flagged';
            }
            lazyTriageActions.lazySetItemsFlagStateFromItemIds.importAndExecute([item.ItemId.Id], null, flagStatusValueToSet, parentFolderId);
            // Reset focus after the stitch to flag the item is raised
            resetFocus();
        };
        return _this;
    }
    MailListItemIconBar.prototype.getHoverActionIcons = function () {
        var _this = this;
        var tableView = listViewStore.tableViews.get(this.props.tableViewId);
        var item = getItemToShowFromNodeId(this.props.nodeId);
        var canDelete = !isGroupTableQuery(tableView.tableQuery);
        var hoverActions = [];
        var isFlagged = item.Flag.FlagStatus == 'Flagged';
        if (canDelete) {
            hoverActions.push({
                iconClasses: getIconClassName("Delete" /* Delete */),
                title: strings.deleteItem,
                key: 'deleteIcon',
                onClickCommand: function () { return _this.deleteRow(item); },
            });
        }
        hoverActions.push({
            iconClasses: getIconClassName("Mail" /* Mail */),
            title: item.IsRead ? strings.markAsUnread : strings.markAsRead,
            key: 'markReadIcon',
            onClickCommand: function () { return _this.toggleMarkAsReadRow(item); },
        });
        if (this.props.tableViewSupportsFlagging) {
            var flagClasses = classNames(isFlagged && styles.flagIcon, getIconClassName("Flag" /* Flag */));
            hoverActions.push({
                iconClasses: flagClasses,
                title: isFlagged ? strings.unflagTitle : strings.flagTitle,
                key: 'flagIcon',
                onClickCommand: function () { return _this.toggleFlaggedStateRow(item); },
            });
        }
        return hoverActions;
    };
    MailListItemIconBar.prototype.getPropertyIconProps = function () {
        var propertyIconProps = [];
        var item = getItemToShowFromNodeId(this.props.nodeId);
        var itemClassIcon = getItemClassIcon([item.ItemClass], item.IconIndex, false /* hasIrm */);
        var isFlagged = item.Flag.FlagStatus == 'Flagged';
        // Build the property icon list from left to right
        // Item class icon first (meeting, note, etc.)
        if (itemClassIcon && itemClassIcon != PropertyIcons.None) {
            propertyIconProps.push({
                iconClasses: getPropertyIconStyle(itemClassIcon),
                key: itemClassIcon.toString(),
            });
        }
        // Importance icon
        if (item.Importance == 'Low') {
            propertyIconProps.push({
                iconClasses: getPropertyIconStyle(PropertyIcons.ImportanceLow),
                key: PropertyIcons.ImportanceLow.toString(),
            });
        }
        else if (item.Importance == 'High') {
            propertyIconProps.push({
                iconClasses: getPropertyIconStyle(PropertyIcons.ImportanceHigh),
                key: PropertyIcons.ImportanceHigh.toString(),
            });
        }
        // Attachment icon
        if (item.HasAttachments) {
            propertyIconProps.push({
                iconClasses: getPropertyIconStyle(PropertyIcons.Attachment),
                key: PropertyIcons.Attachment.toString(),
            });
        }
        // At mention icon
        if (isMailFeatureEnabled('cmp-mentions') && item.MentionedMe) {
            propertyIconProps.push({
                iconClasses: getPropertyIconStyle(PropertyIcons.GlobalMentionedMe),
                key: PropertyIcons.GlobalMentionedMe.toString(),
            });
        }
        // If the conversation/item has like count greater than 0, then show the LikeIcon
        if (isMailFeatureEnabled('rp-like') &&
            !isConsumer() &&
            item.LikeCount &&
            item.LikeCount > 0) {
            propertyIconProps.push({
                iconClasses: getPropertyIconStyle(PropertyIcons.Like),
                key: PropertyIcons.Like.toString(),
            });
        }
        // Flag icon
        if (this.props.tableViewSupportsFlagging && isFlagged) {
            var flagIconClasses = classNames(styles.flagIcon, getIconClassName("Flag" /* Flag */));
            propertyIconProps.push({
                iconClasses: flagIconClasses,
                key: 'flagIcon',
            });
        }
        // If the conversation/item has been snoozed, then show the clock icon
        if (isMailFeatureEnabled('tri-snooze') && item.ReturnTime) {
            propertyIconProps.push({
                iconClasses: getPropertyIconStyle(PropertyIcons.Snooze),
                key: PropertyIcons.Snooze.toString(),
            });
        }
        return propertyIconProps;
    };
    MailListItemIconBar.prototype.render = function () {
        return (React.createElement(IconBar, { hoverActionIcons: this.getHoverActionIcons(), propertyIcons: this.getPropertyIconProps(), backgroundColorClassName: DefaultPalette.neutralLight, iconClass: styles.icon, propertyIconClass: styles.propertyIcon, hoverIconClass: styles.hoverActionIcon, iconBarContainerClass: this.props.isSingleLine
                ? styles.iconBarSingleLineViewContainer
                : styles.iconBarThreeColumnContainer }));
    };
    MailListItemIconBar = tslib_1.__decorate([
        observer
    ], MailListItemIconBar);
    return MailListItemIconBar;
}(React.Component));
export default MailListItemIconBar;
//# sourceMappingURL=MailListItemPartIconBar.js.map